<template>
    <div class="container-fluid" style="min-width: 800px;">
        <!--Quick Summary-->
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3>
                            <span class="label label-cyan" v-if="invoice.status === 'DRAFT'">Draft</span>
                            <span class="label label-brown" v-if="invoice.status === 'VOID'">Void</span>
                            <span class="label label-primary" v-if="invoice.status === 'SENT'">Sent</span>
                            <span class="label label-warning" v-if="invoice.status === 'WRITE-OFF'">Write-Off</span>
                            <span class="label label-light-green" v-if="invoice.status === 'RECORD_PAYMENT'">Payment Recorded</span>
                            <span class="label label-dark-green" v-if="invoice.status === 'PAID'">Paid</span>
                        </h3>
                        <span>Status</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0">{{invoice.buyer.biz_name}}</h3>
                        <span>Buyer</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0" v-if="invoice.amount_due">{{invoice.amount_due | money}}</h3>
                        <span>Amount Due</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 text-right">
                <div class="ml-auto">
                    <div>
                        <h3 class="font-medium text-right m-b-0">{{invoice.due_at || "—" | medium}}</h3>
                        <span class="text-right">Due Date</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row hide">
            <div class="col-md-12">
                <div class="card card-shadow printableArea" id="printMe">
                    <div class="card-header border-bottom">
                        <div class="d-md-flex align-items-center m-t-20">
                            <div class="d-flex align-items-center">
                                <div>
                                    <h3 class="font-medium m-b-0">{{invoice.invoice_number}}</h3>
                                    <h6 class="text-muted m-t-5">Invoice Date {{invoice.created_at | date}}</h6>
                                    <h6 class="text-muted m-t-5">Due on {{invoice.due_at | date}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-blue card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed From</h5>
                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.seller.line1}}, &nbsp;{{invoice.seller.line2}}<br/>
                                    {{invoice.seller.country}},&nbsp;{{invoice.seller.city}}<br/>
                                    {{invoice.seller.state}},&nbsp;{{invoice.seller.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.seller.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.seller.biz_email}}<br/>
                                    <span v-html="invoice.seller.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">PO Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.po||invoice.notes }}</h4>-->

                                <div class="row">
                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. #</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.po:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.created_at:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Due Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.due_at | medium}}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Other Reference</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.notes}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row m-t-20">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed To</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.buyer.line1}}, &nbsp;{{invoice.buyer.line2}}<br/>
                                    {{invoice.buyer.country}},&nbsp;{{invoice.buyer.city}}<br/>
                                    {{invoice.buyer.state}},&nbsp;{{invoice.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}<br/>
                                    <span v-html="invoice.buyer.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Shipping Infromation</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.shipping_address.line1}}, &nbsp;{{invoice.shipping_address.line2}}<br/>
                                    {{invoice.shipping_address.country}},&nbsp;{{invoice.shipping_address.city}}<br/>
                                    {{invoice.shipping_address.state}},&nbsp;{{invoice.shipping_address.zip}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}
                                </p>
                            </div>
                        </div>

                        <div class="row m-t-40">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Items</h5>
                            </div>

                            <div class="col-md-12">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered font-10" style="font-size: small;">
                                        <thead class="text-center">
                                        <tr>
                                            <th class="p-1 font-weight-bold" rowspan="2">#</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Name<br>(Code)</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Quantity</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Rate</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Total</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Discount</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Taxable Value</th>
                                            <th class="p-1 font-weight-bold" colspan="2">CGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">SGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">IGST</th>
                                        </tr>
                                        <tr>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(ini, index) in invoice.invoice_items">
                                            <td class="p-1">{{index + 1}}</td>
                                            <td class="p-1">{{ini.name}} - {{ini.variety}}<br>({{ini.code}})</td>
                                            <td class="p-1 text-right">{{ini.quantity | units}}</td>
                                            <td class="p-1 text-right">{{ini.amount.currency_symbol}}{{ini.rate}}/{{ini.quantity.unitSymbol}}</td>
                                            <td class="p-1 text-right">{{ini.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in ini.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(ini) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getCGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getSGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getIGST(ini.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p-1"></td>
                                            <td class="p-1" colspan="3">Freight Insurance Packing and Forwarding Charges</td>
                                            <td class="p-1 text-right">{{other.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in other.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(other) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getCGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getSGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getIGST(other.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td colspan="2" class="p-1 text-right">Total</td>
                                            <td class="p-1 text-right">{{invoice.subtotal | money}}</td>
                                            <td class="p-1 text-right">{{invoice.discount | money}}</td>
                                            <td class="p-1 text-right">{{invoice.taxable_total | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.cgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.sgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.igst | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Figure)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Words)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total.currency_symbol}} {{invoice.total.amount| unitFix(2) |words}} Only</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1">Amount of Tax subject to Reverse Charges</td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <p>We declare that the value mentioned in the Invoice is sole consideration for the supply , apart from the said amount , we have not received any other consideration
                                    in any other form for the said supply.</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8">
                                <h5 class="font-bold text-muted">Payment Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>-->
                                <div class="row">
                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Payment Terms</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.terms }}</div>

                                    <div class="col-12 font-weight-bold"><u>Company Bank Details</u></div>

                                    <!--                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Company Name</div>-->
                                    <!--                                    <div class="col-sm-9 col-lg-10">: {{invoice.seller.biz_name}}</div>-->

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Name</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.bank}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Address</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.address}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Account No</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.ac}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">IFSC Code</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.ifsc}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Swift Code</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.swift}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">MICR Code</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.micr}}</div>
                                </div>
                            </div>
                            <div class="col-sm-4 row">
                                <div class="col-12 border text-center h-50 position-absolute fixed-bottom">
                                    Office Use Only
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-shadow printableArea">
                    <div class="card-header border-bottom">
                        <div class="d-md-flex align-items-center m-t-20">
                            <div class="d-flex align-items-center">
                                <div>
                                    <h3 class="font-medium m-b-0">{{invoice.invoice_number}}</h3>
                                    <h6 class="text-muted m-t-5">Invoice Date {{invoice.created_at | date}}</h6>
                                    <h6 class="text-muted m-t-5">Due on {{invoice.due_at | date}}</h6>
                                </div>
                            </div>
                            <div class="ml-auto">
                                <router-link :to="{'name': 'editexpressinvoice', 'params': {invoiceid: invoiceid}}" class="btn btn-default btn-outline" v-if="invoice.status === 'DRAFT'">
                                    <span>
                                        <i class="fas fa-pencil-alt"></i> Edit
                                    </span>
                                </router-link>
                                <button @click="sendInvoice" class="btn btn-success btn-outline m-l-5" id="send" type="button" v-if="invoice.status === 'DRAFT'">
                                    <span>
                                        <i class="fas fa-paper-plane"></i> Send
                                    </span>
                                </button>
                                <button @click="printInvoice" class="btn btn-secondary btn-outline m-l-5" id="print" type="button">
                                    <span>
                                        <i class="fa fa-print"></i> Print
                                    </span>
                                </button>
                                <button @click="copyInvoice" class="btn btn-info btn-outline m-l-5" id="copy" type="button" v-if="invoice.status === 'DRAFT'">
                                    <span>
                                        <i class="fa fa-copy"></i> Copy
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-blue card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed From</h5>
                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.seller.line1}}, &nbsp;{{invoice.seller.line2}}<br/>
                                    {{invoice.seller.country}},&nbsp;{{invoice.seller.city}}<br/>
                                    {{invoice.seller.state}},&nbsp;{{invoice.seller.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.seller.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.seller.biz_email}}<br/>
                                    <span v-html="invoice.seller.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">PO Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.po||invoice.notes }}</h4>-->

                                <div class="row">
                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. #</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.po:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.created_at:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Due Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.due_at | medium}}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Other Reference</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.notes}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row m-t-20">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed To</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.buyer.line1}}, &nbsp;{{invoice.buyer.line2}}<br/>
                                    {{invoice.buyer.country}},&nbsp;{{invoice.buyer.city}}<br/>
                                    {{invoice.buyer.state}},&nbsp;{{invoice.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}<br/>
                                    <span v-html="invoice.buyer.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Shipping Infromation</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.shipping_address.line1}}, &nbsp;{{invoice.shipping_address.line2}}<br/>
                                    {{invoice.shipping_address.country}},&nbsp;{{invoice.shipping_address.city}}<br/>
                                    {{invoice.shipping_address.state}},&nbsp;{{invoice.shipping_address.zip}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}
                                </p>
                            </div>
                        </div>

                        <div class="row m-t-40">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Items</h5>
                            </div>

                            <div class="col-md-12">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered font-10" style="font-size: small;">
                                        <thead class="text-center">
                                        <tr>
                                            <th class="p-1 font-weight-bold" rowspan="2">#</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Name<br>(Code)</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Quantity</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Rate</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Total</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Discount</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Taxable Value</th>
                                            <th class="p-1 font-weight-bold" colspan="2">CGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">SGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">IGST</th>
                                        </tr>
                                        <tr>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(ini, index) in invoice.invoice_items">
                                            <td class="p-1">{{index + 1}}</td>
                                            <td class="p-1">{{ini.name}} - {{ini.variety}}<br>({{ini.code}})</td>
                                            <td class="p-1 text-right">{{ini.quantity | units}}</td>
                                            <td class="p-1 text-right">{{ini.amount.currency_symbol}}{{ini.rate}}/{{ini.quantity.unitSymbol}}</td>
                                            <td class="p-1 text-right">{{ini.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in ini.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(ini) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getCGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getSGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getIGST(ini.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p-1"></td>
                                            <td class="p-1" colspan="3">Freight Insurance Packing and Forwarding Charges</td>
                                            <td class="p-1 text-right">{{other.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in other.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(other) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getCGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getSGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getIGST(other.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td colspan="2" class="p-1 text-right">Total</td>
                                            <td class="p-1 text-right">{{invoice.subtotal | money}}</td>
                                            <td class="p-1 text-right">{{invoice.discount | money}}</td>
                                            <td class="p-1 text-right">{{invoice.taxable_total | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.cgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.sgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.igst | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Figure)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Words)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total.currency_symbol}} {{invoice.total.amount| unitFix(2) |words}} Only</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1">Amount of Tax subject to Reverse Charges</td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <p>We declare that the value mentioned in the Invoice is sole consideration for the supply , apart from the said amount , we have not received any other consideration
                                    in any other form for the said supply.</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8">
                                <h5 class="font-bold text-muted">Payment Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>-->
                                <div class="row">
                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Payment Terms</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.terms }}</div>

                                    <div class="col-12 font-weight-bold"><u>Company Bank Details</u></div>

                                    <!--                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Company Name</div>-->
                                    <!--                                    <div class="col-sm-9 col-lg-10">: {{invoice.seller.biz_name}}</div>-->

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Name</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.bank}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Address</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.address}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Account No</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.ac}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">IFSC Code</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.ifsc}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Swift Code</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.swift}}</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">MICR Code</div>
                                    <div class="col-sm-9 col-lg-10">: {{invoice.bank_account.micr}}</div>
                                </div>
                            </div>
                            <div class="col-sm-4 row">
                                <div class="col-12 border text-center h-50 position-absolute fixed-bottom">
                                    Office Use Only
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapGetters} from "vuex";
    import Blockie from '../../../common/Blockie';

    export default {
        name: "ViewInvoice",
        components: {Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        props: ["invoiceid"],
        data() {
            return {
                invoice: {
                    status: null,
                    buyer: {
                        name: null,
                        biz_name: null,
                        biz_email: null,
                        biz_phone: null,
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null,
                        country_code: null
                    },
                    seller: {
                        name: null,
                        biz_name: null,
                        biz_email: null,
                        biz_phone: null,
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null,
                        country_code: null
                    },
                    shipping_address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null,
                        country_code: null
                    },
                    due_at: null,
                    total: {
                        amount: 0
                    },
                    bank_account: {},
                    taxable_total: {},
                    subtotal: {
                        amount: null
                    },
                    tax: null,
                    discount: {
                        amount: null
                    },
                    cgst: {
                        amount: null
                    },
                    sgst: {
                        amount: null
                    },
                    igst: {
                        amount: null
                    },
                    items: []
                },
                other: {
                    "quantity": {},
                    "amount": {},
                    "taxes": [],
                    "reductions": []
                },
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getInvoice();
            },
            async getInvoice() {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/invoices/${this.invoiceid}`);
                    $(".preloader").fadeOut();
                    this.invoice = reply.data;
                    await this.calculateAmount();
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            async calculateAmount() {
                let subAmount      = _.sumBy(this.invoice.invoice_items, function(o) {
                    return o.amount.amount;
                });
                let taxAmount      = 0,
                    discountAmount = 0;

                this.invoice.cgst = {
                    amount: 0,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.sgst = {
                    amount: 0,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.igst = {
                    amount: 0,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                _.forEach(this.invoice.invoice_items, ini => {
                    let tax = 0;

                    let rate = _.sumBy(ini.taxes, function(o) {
                        return o.tax.rate;
                    });

                    let discount = _.sumBy(ini.reductions, function(o) {
                        return o.amount.amount;
                    });

                    discountAmount = Number(discountAmount) + Number(discount);
                    let taxable    = Number(ini.rate) * Number(ini.quantity.amount) - discountAmount;

                    ini.taxes.forEach(t => {
                        if(t.name === 'CGST') {
                            this.invoice.cgst.amount += taxable * Number(t.rate) / 100;
                        } else if(t.name === 'SGST') {
                            this.invoice.sgst.amount += taxable * Number(t.rate) / 100;
                        } else if(t.name === 'IGST') {
                            this.invoice.igst.amount += taxable * Number(t.rate) / 100;
                        }

                        tax += taxable * Number(t.rate) / 100;
                    });

                    taxAmount = Number(taxAmount) + Number(tax);
                });

                this.invoice.tax = {
                    amount: taxAmount,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.discount = {
                    amount: discountAmount,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.subtotal = {
                    amount: Number(subAmount) - Number(discountAmount),
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.subtotal = {
                    amount: Number(subAmount),
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.taxable_total = {
                    amount: Number(subAmount) - Number(discountAmount),
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                let other = _.remove(this.invoice.invoice_items, {'name': 'OTHERS'});

                if(other.length > 0) {
                    this.other = other[0];
                }
            },
            printInvoice() {
                this.$htmlToPaper('printMe');
            },
            async sendInvoice() {
                try {
                    await this.$http.post(`/express/${this.currentOrg.express_id}/invoices/${this.invoiceid}/send`, {
                        comments: null
                    });
                    this.init();
                } catch(e) {
                    console.dir(e);
                    if(e.response.data.status === 500) {
                        this.$toastr('error', e.response.data.reason, 'Error!');
                    }
                } finally {
                }
            },
            getTaxableValue(item) {
                let total = item.amount.amount;
                let reds  = _.sumBy(item.reductions, 'amount.amount');
                return {
                    ...item.amount,
                    amount: total - reds
                }
            },
            getCGST(taxes) {
                let tax = _.filter(taxes, {name: 'CGST'});
                return tax[0] || {rate: 0};
            },
            getSGST(taxes) {
                let tax = _.filter(taxes, {name: 'SGST'});
                return tax[0] || {rate: 0};
            },
            getIGST(taxes) {
                let tax = _.filter(taxes, {name: 'IGST'});
                return tax[0] || {rate: 0};
            },
            getTaxAmount(taxable, rate) {
                return {...taxable, amount: taxable.amount * rate / 100}
            },
            async copyInvoice() {
                try {
                    let {data} = await this.$http.post(`/express/${this.currentOrg.express_id}/invoices/${this.invoiceid}/copy`);
                    this.$router.push({'name': 'editexpressinvoice', 'params': {invoiceid: data.invoiceid}});
                } catch(e) {
                    console.dir( e.response.data);
                    this.$toastr('error', e.response.data.msg, 'Error!');
                } finally {
                }
            }
        }
    }
</script>

<style scoped>
    .b-t-0 {
        border-top: 0;
    }

    .b-b-0 {
        border-bottom: 0;
    }

    .h-150 {
        height: 100px;
    }
</style>
